import { setMinutes, setHours, format, addMinutes, getMinutes } from 'date-fns'

export interface DateTimeRangeProps {
  date: string
  startTime: string
  durationInMinutes?: number
}

export class DateTimeRange {
  public constructor(props: DateTimeRangeProps) {
    Object.assign(this, props)
  }

  public date!: string
  public startTime!: string
  public durationInMinutes?: number

  public get rangeString() {
    return this.startTimeString + ' – ' + this.endTimeString
  }

  public get startTimeString() {
    if (getMinutes(this.startDateTime) === 0) {
      return this.formatStart('ha')
    } else {
      return this.formatStart('h:mma')
    }
  }

  public get endTimeString() {
    if (getMinutes(this.endDateTime) === 0) {
      return this.formatEnd('ha')
    } else {
      return this.formatEnd('h:mma')
    }
  }

  public formatStart(fmt: string) {
    return format(this.startDateTime, fmt)
  }

  public formatEnd(fmt: string) {
    return this.endDateTime && format(this.endDateTime, fmt)
  }

  private get startDateTime() {
    const [h, m] = this.startTime.split(':').map(Number)
    return setMinutes(setHours(this.date, h), m)
  }

  private get endDateTime() {
    return (
      this.durationInMinutes &&
      addMinutes(this.startDateTime, this.durationInMinutes)
    )
  }
}
